import { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Form,
    FormGroup,
    Input,
    Label,
    Spinner
} from "reactstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { useAuth } from "../../../context/AuthContext"; 
import { login } from "../../../common/auth/service/authApi";
import "./InlineLoginForm.css";

interface Props {
    onLoginSuccess?: () => void;
    inline?: boolean;
}

const InlineLoginForm = ({ onLoginSuccess, inline = false }: Props) => {
 

    const { login: saveLogin } = useAuth();

    const [loading, setLoading] =        useState(false);

    const [showPassword, setShowPassword] =        useState(false);

    const [formData, setFormData] = useState({ email: "", password: "" });

    const handleChange = (         e: React.ChangeEvent<HTMLInputElement>    ) => {

        setFormData({

            ...formData,

            [e.target.name]:
                e.target.value

        });

    };

    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (!formData.email.trim()) {

            toast.error("Email is required");

            return;

        }

        if (!formData.password.trim()) {

            toast.error("Password is required");

            return;

        }

        try {

            setLoading(true);

            const response =
                await login(formData);

            saveLogin(

                response.token,

                response.userID,

                response.email,

                response.role

            );

            toast.success("Login Successful");

            // Used by GroupJoinStatus
            onLoginSuccess?.();

            // Don't navigate if inside Group Details
            if (inline) {

    onLoginSuccess?.();

    return;

}

            // if (
            //     response.role === "Admin" ||
            //     response.role === "SuperAdmin"
            // ) {

            //     navigate("/admin");

            // }
            // else if (
            //     response.role === "Coordinator"
            // ) {

            //     navigate("/coordinator");

            // }
            // else {

            //     navigate("/");

            // }

        }
        catch (error: any) {

            toast.error(

                error?.response?.data?.message ||

                "Invalid email or password"

            );

        }
        finally {

            setLoading(false);

        }

    };

  const content = (
<div
  style={{
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop:"-100px"
  }}
>
  <div className="container">
    <div
      className="row shadow-lg overflow-hidden login-card mx-auto"
      style={{
        maxWidth: "1100px",
        borderRadius: "25px",
        background: "#fff",
      }}
    >


      {/* Right Section */}
      <div className="col-lg-12 col-12">
        <div className="p-4 p-md-5">

          <div className="text-center mb-4">

            <div className="logo-circle mb-3">
              PW
            </div>

            <h2 className="fw-bold login-title">
              Login
            </h2>

            <p className="text-muted">
              Login to chat with your coordinator and connect
              with your group members.
            </p>

          </div>

          <Form onSubmit={handleSubmit}>

            <FormGroup floating className="mb-3">
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder=""
              />
              <Label>Email Address</Label>
            </FormGroup>

            <FormGroup floating className="mb-3">
              <Input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder=""
              />
              <Label>Password</Label>
            </FormGroup>

            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">

              <FormGroup check className="mb-2 mb-md-0">
                <Input
                  type="checkbox"
                  onChange={() =>
                    setShowPassword(!showPassword)
                  }
                />
                <Label check>
                  Show Password
                </Label>
              </FormGroup>

              <Link
                to="/forgot-password"
                className="text-decoration-none fw-semibold"
              >
                Forgot Password?
              </Link>

            </div>

            <Button
              type="submit"
              className="w-100 login-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    size="sm"
                    className="me-2"
                  />
                  Logging in...
                </>
              ) : (
                "Login"
              )}
            </Button>

            <div className="text-center mt-4">
              Don't have an account?
              <Link
                to="/register"
                className="fw-bold ms-1 text-decoration-none"
              >
                Create Free Account
              </Link>
            </div>

          </Form>

        </div>
      </div>
    </div>
  </div>
</div>
);

    if (inline) {
    return (
        <Card
            className="border shadow-lg"
            style={{
                borderRadius: "20px",
                background: "#f8fbff",
                width:"75%",margin:'0 auto'
            }}
        >
            <CardBody className="p-5"  
            >
                {content}
            </CardBody>
        </Card>
    );
}

    return content;

};

export default InlineLoginForm;